import { Button, Text } from "@ucl/react-library";
import { useTranslation } from "react-i18next";
import { useCase } from "src/context/case-context";
import { ContactExplanation } from "../contact-info/contact-explanation";

type ContactDetailsViewProps = {
  toggleContactDetails: () => void;
  showContactExplanation?: boolean;
};

export const ContactDetailsView = ({ toggleContactDetails, showContactExplanation = false }: ContactDetailsViewProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "contactDetails",
  });

  const { customerData } = useCase();

  if (!customerData) {
    return null;
  }

  const { fullName, email, homePhone, address } = customerData;

  return (
    <div className="flex w-full flex-col items-start gap-5" data-testid="viewContactDetails">
      <div className="flex flex-col gap-2">
        <Text.P size="large" fontWeight="semi-bold">
          {t("name")}
        </Text.P>

        <Text.P size="large" data-testid="fullNameView">
          {fullName}
        </Text.P>
      </div>

      <div className="flex flex-col gap-2">
        <Text.P size="large" fontWeight="semi-bold">
          {t("email")}
        </Text.P>

        <Text.P size="large" data-testid="emailView">
          {email || "-"}
        </Text.P>
      </div>

      <div className="flex flex-col gap-2">
        <Text.P size="large" fontWeight="semi-bold">
          {t("phoneNumber")}
        </Text.P>

        <Text.P size="large" data-testid="phoneNumberView">
          {homePhone || "-"}
        </Text.P>
      </div>

      <div className="flex flex-col gap-2">
        <Text.P size="large" fontWeight="semi-bold">
          {t("address")}
        </Text.P>

        <div>
          <Text.P size="large" data-testid="streetView">
            {address.streetName}
          </Text.P>

          <Text.P size="large" data-testid="cityView">
            {address.city}
          </Text.P>

          <Text.P size="large" data-testid="countyView">
            {address.county}
          </Text.P>

          <Text.P size="large" data-testid="postcodeView">
            {address.postCode}
          </Text.P>

          <Text.P size="large" data-testid="countryView">
            {address.country}
          </Text.P>
        </div>
      </div>

      {showContactExplanation && <ContactExplanation contactType={customerData.preferredContactChannel} />}

      <Button variant="secondary" type={"button"} fullWidthMobile onClick={toggleContactDetails}>
        {t("updateContactDetails")}
      </Button>
    </div>
  );
};
